import { CEBacklogAttributesBase } from './ce-backlog-attributes-base'


export class CEBacklogAttributes extends CEBacklogAttributesBase {

}